import { createAction } from '@reduxjs/toolkit';
import type { RawSubcatalogAPIData } from 'types/catalog_types';

export type FetchSubcatalogsFulfilledPayload = {
  subcatalogs: RawSubcatalogAPIData[];
  catalogId: number;
};

const fetchSubcatalogs = {
  pending: createAction<number>('subcatalogs/fetchSubcatalogs/pending'),
  fulfilled: createAction<FetchSubcatalogsFulfilledPayload | null>(
    'subcatalogs/fetchSubcatalogs/fulfilled'
  ),
  rejected: createAction('subcatalogs/fetchSubcatalogs/rejected'),
};

export default { fetchSubcatalogs };
